interface RichTextFont {
  bold?: boolean;
  italic?: boolean;
}

interface RichTextRun {
  text: string;
  font?: RichTextFont;
}

interface RichValue {
  richText: RichTextRun[];
}

function isRichValue(value: unknown): value is RichValue {
  return Boolean(
    value &&
    typeof value === 'object' &&
    Array.isArray((value as RichValue).richText),
  );
}

function richToString(rich: RichValue): string {
  return rich.richText.map(({ text }) => text).join('');
}

function parseCell(cell: string): string {
  return isRichValue(cell) ? richToString(cell) : cell;
}

export { parseCell };
